<template>
    <div
        :class="[{ 'has-options-menu': inCourse(course.id) }]"
        class="menu-container"
    >
        <BtnMenuShare
            :share-title="
                t('share.title', {
                    name: course.name,
                })
            "
            :share-url="url"
            :variant="screen.maxSM ? 'filled' : 'outlined'"
            :elevated="screen.maxMD"
            size="sm"
            class="w-full"
            menu-class="flex-1"
        />
        <Btn
            v-if="inCourse(course.id)"
            v-tooltip="t('tooltip:leave:course')"
            :variant="screen.maxSM ? 'filled' : 'outlined'"
            size="sm"
            icon="logout"
            class="flex-1 md:flex"
            :elevated="screen.maxMD"
            @click="leaveCourse"
        />
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import stripWhiteSpaceSpecialCharacters from '@/helpers/stripWhiteSpaceSpecialCharacters';
import GtmMixin, { GtmEventName } from '@/mixins/gtmMixin';
import route from '@router/route';
import BtnMenuShare from '@/components/BtnMenuShare';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'CourseShowMenu',
    components: {
        BtnMenuShare,
    },
    extends: GtmMixin,
    props: {
        withBanner: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { t } = useTranslation('course');
        return { t };
    },
    computed: {
        ...mapGetters({
            course: 'course/course',
            leavingCourse: 'course/leaveProgress',
            joiningCourse: 'course/joinProgress',
        }),
        ...mapGetters({
            userCourses: 'user/courses',
            inCourse: 'user/inCourse',
        }),
        ...mapGetters({ user: 'auth/user' }),
        ...mapGetters('ui', ['screen']),
        url() {
            return route('course.show', {
                courseName: this.course.slug || '',
                id: this.course.id || '',
                ref: this.user ? this.user.userid : null,
            });
        },
    },
    methods: {
        async leaveCourse() {
            if (!this.inCourse(this.course.id) || this.leavingCourse || this.joiningCourse) {
                return;
            }

            const data = await this.$modal.open(
                defineAsyncComponent(() => import('@/components/ModalConfirmCourseLeave')),
            );
            if (!data) return;

            await this.$store.dispatch('course/leave', {
                course: this.course,
                keepFollowedDocuments: data.keepDocuments,
            });

            this.pushGtmEvent(GtmEventName.LEAVE_COURSE);
        },
        stripWhiteSpaceSpecialCharacters,
    },
};
</script>
<style lang="scss" scoped>
.menu-container {
    @apply flex flex-row justify-between container space-x-4 w-full py-4 bg-white;

    @screen md {
        @apply absolute top-0 right-0 justify-end p-6 bg-transparent w-auto;
    }
}
</style>
